<template>
  <b-container v-if="!isLoading" fluid>
    <b-row class="d-flex my-4 border-bottom pb-2">
      <b-col class="order-2 order-md-1 my-2" cols="12" md="6">
        <h1 class="my-auto mb-2">{{ meeting.name }}</h1>
        <b-breadcrumb></b-breadcrumb>
      </b-col>
      <b-col
        v-if="meeting.status == meetingStatuses.started"
        class="order-1 order-md-2 d-flex justify-content-center align-items-end justify-content-md-end"
        cols="12"
        md="6"
      >
        <b-button
          class="my-4 mr-2 px-2"
          :class="[
            $route.name == 'meeting-start' && page == pages.currentResolution
              ? 'btn-green'
              : 'btn-grey',
          ]"
          @click="setPage(pages.currentResolution)"
        >
          <font-awesome-icon class="agv-button-icon" icon="vote-yea" />
          <span v-if="currentResolution.status != meetingResolutionStatuses.started">
            Résolution présentée
          </span>
          <span v-else>Résolution en cours de vote</span>
        </b-button>
        <b-button
          v-if="
            meeting.allowed_modalities.video &&
            meeting.current_resolution_id &&
            !meeting.external_video_solution
          "
          class="my-4 mr-2 px-2"
          :class="[
            $route.name == 'meeting-start' && page == pages.video ? 'btn-green' : 'btn-grey',
          ]"
          @click="setPage(pages.video)"
        >
          <font-awesome-icon class="agv-button-icon" icon="video" />
          <span>Videoconférence</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="meeting.status == meetingStatuses.started">
      <appCurrentResolution
        :class="{ 'd-none': page != pages.currentResolution }"
        :current-resolution="currentResolution"
      ></appCurrentResolution>
      <appLivekit
        v-if="meeting.allowed_modalities.video"
        :class="{ 'd-none': page != pages.video }"
        :meeting-room-name="meeting.meeting_room_name"
      />
    </b-row>
    <b-row
      v-if="meeting.status < meetingStatuses.started && meeting.status != meetingStatuses.completed"
    >
      <h2 class="text-center mx-auto my-4">La réunion débutera dans quelques minutes.</h2>
    </b-row>
    <b-row
      v-if="
        meeting.status == meetingStatuses.completed ||
        meeting.status == meetingStatuses.pvReadyToBeSent ||
        meeting.status == meetingStatuses.pvInProgress ||
        meeting.status == meetingStatuses.pvSent
      "
    >
      <b-col col="12">
        <div class="d-flex justify-content-center align-items-center mt-5">
          <h4 v-if="!hasMeetingGuest">Merci pour vote participation&nbsp;!</h4>
          <h4 v-else>Cette réunion est terminée, veuillez contacter l'administrateur.</h4>
          <div v-if="!hasMeetingGuest" class="ml-4 mb-2">
            <b-button variant="primary" @click="goToMeetings"> Convocations </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <appLoader v-else />
</template>

<script>
import MeetingsMercure from "@/mixins/mercure-live-changes/meetings";
import MeetingResolutionsMercure from "@/mixins/mercure-live-changes/meeting-resolutions";
import MandatesMercure from "@/mixins/mercure-live-changes/mandates";
import MeetingGuestMercure from "@/mixins/mercure-live-changes/meeting-guests.js";

import MeetingDetailsMixin from "@/mixins/meeting-details";

import MandateORM from "@/store/orm-axios/models/Mandate";
import MeetingORM from "@/store/orm-axios/models/Meeting";
import MeetingStartMixin from "@/mixins/meeting-start.js";
import MeetingGuestORM from "@/store/orm-axios/models/MeetingGuest";
import { meetingGuestAccessStatuses } from "@/constants/meeting-guests.js";
export default {
  components: {
    appCurrentResolution: () => import("@/components/MeetingStart/CurrentResolution"),
    appLivekit: () => import("@/components/MeetingStart/Livekit"),
  },
  mixins: [
    MeetingStartMixin,
    MeetingResolutionsMercure,
    MeetingsMercure,
    MandatesMercure,
    MeetingDetailsMixin,
    MeetingGuestMercure,
  ],
  data() {
    return {
      meetingId: null,
      page: 1,
      pages: {
        currentResolution: 1,
        video: 2,
      },
      generalDetailsSet: false,
      isLoading: true,
      meetingGuestAccessStatuses,
    };
  },
  computed: {
    meeting() {
      return MeetingORM.find(this.$route.params.id);
    },
    mandate() {
      return MandateORM.query()
        .where(mandate => {
          return (
            mandate.meeting_id == this.$route.params.id &&
            mandate.building_owner_id == this.building_owner_id
          );
        })
        .withAllRecursive(2)
        .first();
    },
    currentResolution() {
      if (this.meeting) {
        return this.getCurrentResolution(this.meeting);
      } else {
        return null;
      }
    },
    hasMeetingGuest() {
      return localStorage.meeting_guest_id ? true : false;
    },
    meetingGuest() {
      return MeetingGuestORM.find(localStorage.meeting_guest_id);
    },
  },
  watch: {
    meeting(newVal, oldVal) {
      if (newVal && newVal != oldVal && !this.generalDetailsSet) {
        var generalDetails = this.$_.filter(newVal.minutes, minute => {
          return minute.event == "general-details";
        });
        if (generalDetails[0]) {
          this.$store.state.votingLimitRules = generalDetails[0];
          this.generalDetailsSet = true;
        }
      }
    },
    meetingGuest(newVal) {
      if (newVal && newVal.access_status == this.meetingGuestAccessStatuses.deny) {
        this.logout();
      }
    },
  },
  created() {
    this.onMeetingStartCreated();
  },
  methods: {
    setPage(pageType) {
      this.page = pageType;
    },
    goToMeetings() {
      this.$router.push({
        name: "meetings",
      });
    },
    logout() {
      this.isLoading = true;
      this.$fire({
        text: "Accès refusé par l'agence !",
        title: "Attention",
        type: "warning",
        timer: 7000,
      });
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>
